export const has = (object, path, fallback) => {
	const hasProperty = _.has(object, path)
	return hasProperty ? _.get(object, path) : fallback
}
